<template>
  <div id="order-files-box" v-if="visible">
    <el-dialog
      :title="title"
      class="order-files-dialog"
      ref="orderFilesDialog"
      :visible.sync="visible"
      :show-close="true"
      :close-on-click-modal="false"
      width="720px"
      destroy-on-close
      v-el-drag-dialog
    >
      <upload-files
        v-if="!this.viewmode"
        :files="fileList"
        :max="maxFiles"
        :acceptFileTypes="accetpList"
        @filelist-change="onUploadFilesChange"
        :viewmode="viewmode"
      />
      <el-table
          v-else
          border
          :data="fileList"
          style="width: 100%;font-size:12px!important;">
          <el-table-column prop="name" label="附件名称" min-width="200" align="center"></el-table-column>
          <el-table-column prop="url" label="下载" width="150" align="center"> 
            <template slot-scope="scope">
              <el-link icon="el-icon-download" :href="scope.row.url" target="_blank">下载附件</el-link>
            </template>
          </el-table-column>
        </el-table>
      <span slot="footer" class="dialog-footer" v-if="!this.viewmode">
        <el-button
          size="small"
          icon="el-icon-check"
          type="primary"
          @click.stop.prevent="onOK()"
          >提  交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UploadFiles from "@/components/UploadFiles"

export default {
  name: 'CrossUserAnnexesDownload',
  components: { UploadFiles },
  data() {
    return {
      visible: false,
      fileList: [],
      maxFiles: 8,
      accetpList: [],
      title: "模板附件下载",
      viewmode: false
    }
  },
  props: {
    files: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: () => 8
    },
    acceptFileTypes: {
      type: Array,
      default: () => ['PNG', 'JPG', 'GIF', 'JPEG', 'PDF', 'RAR', 'Zip', '7Z', 'DOC', 'DOCX', 'XLS', 'XLSX']
    },
    readOnly: {
      type: Boolean,
      default: () => false
    },
  },
  destroyed() {
    document.body.removeChild(this.$el);
  },
  updated() {
    if (!this.visible) {
      this.$destroy();
    }
  },
  mounted() {
    this.fileList = [...this.files]
    this.maxFiles = this.max
    this.accetpList = [...this.acceptFileTypes]
    this.viewmode = this.readOnly
  },
  methods: {
    Options({ files = [], max = 8, acceptFileTypes = ['PDF'], readOnly = false , title = "模板附件下载"}) {
      this.fileList = [...files]
      this.maxFiles = max
      this.accetpList = [...acceptFileTypes]
      this.viewmode = readOnly
      this.title = title
      console.log(this.fileList)
    },
    Open(onOkCallback) {
      this.visible = true;
      this.onOkCallback = onOkCallback
    },
    onOK() {
        if(typeof this.onOkCallback === 'function') {
            this.onOkCallback([...this.fileList],()=>this.visible = false)
        }        
     },
    onUploadFilesChange(files) {
      this.fileList = files
    }
  }

}
</script>

<style lang="scss">
.order-files-dialog {
  height: 100% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  .el-dialog {
    max-height: 95% !important;
    min-height: 300px !important;
    max-width: 95% !important;
    min-width: 540px !important;
    display: flex;
    flex-direction: column;
    position: relative !important;
    margin:0 auto !important;

    .el-dialog__body {
      padding: 15px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
      flex: 1;
      height: 99% !important;
      overflow-y: scroll;
      position: relative !important;
    }
  }
}
</style>